import script from "./add-edit-podcast.vue?vue&type=script&setup=true&lang=js"
export * from "./add-edit-podcast.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__